import { MixedItem } from 'store/railsBuilder/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import { isAssetVod } from 'utils/checkVodType';

import getRBAssetChannelId from './getRBAssetChannelId';
import getRBVodEditorialDetailsParams from './getRBVodEditorialDetailsParams';
import getTechnicalTime from './utils/getTechnicalTime';
import parseParentalRating from './utils/parseParentalRating';

function parseRBVodEditorialToMixedItem(vodEditorial: VodEditorial): MixedItem {
    const {
        id,
        type,
        contentType,
        playbackType,
        title,
        Title,
        seriesRef,
        SeasonNumber,
        episodeNumber,
        Episode,
        technicals,
        Year,
        CUEndDate,
        isSTCU,
        isLTCU,
        links,
        Countries,
        Genre,
        position,
        duration,
    } = vodEditorial;
    const isVOD = isAssetVod(playbackType);

    return {
        id: id || 'unknown',
        type,
        contentType,
        playbackType,
        CUEndDate,
        links,
        position,
        duration,
        title: title || Title || '',
        channelId: getRBAssetChannelId(vodEditorial),
        seriesId: seriesRef,
        season: SeasonNumber,
        episode: episodeNumber,
        episodeTitle: Episode,
        startTime: isVOD
            ? undefined
            : getTechnicalTime(technicals?.[0].ProgrammeStartDate),
        endTime: isVOD
            ? undefined
            : getTechnicalTime(technicals?.[0].ProgrammeEndDate),
        year: Year,
        parentalRating: parseParentalRating(vodEditorial),
        isCatchUp: isSTCU || isLTCU,
        countries: Countries,
        genres: Genre,
        isStartOver: true,
        detailsPageParams: getRBVodEditorialDetailsParams(vodEditorial),
        vodProductIds: technicals?.[0].products?.map((product) => product.id),
        vodStartTime: technicals?.[0]?.period?.start,
    };
}

export default parseRBVodEditorialToMixedItem;
